import api from '../config/axiosConfig';

export const RegionService = {
  fetchRegiones: async (token) => {
    try {
      const response = await api.get('/locations/regiones', {
        headers: { Authorization: `Bearer ${token}` },
      });

      return response.data || [];
    } catch (error) {
      console.error('Error en RegionService.fetchRegiones:', error);
      throw error;
    }
  },
};
